import { AloBase, getDefaultAloBase } from './AloBase'


export interface AloGroupCarac extends AloBase {    
    grcDesc:string
    grcParamJson:{caracIdxcs:Array<number>,grcMetaKey:string,grcMetaKeyGgl:string}
    grcDisabled:boolean
}

export const getDefaultAloGroupCarac = ():AloGroupCarac => {
    return {
        ...getDefaultAloBase(),
        grcDesc:'',
        grcParamJson:{
            caracIdxcs:[],
            grcMetaKey:'',
            grcMetaKeyGgl:''
        },
        grcDisabled:false
    }
}

export const cleanAloGroupCarac = (grc:AloGroupCarac) => {
    if(!grc) return
    if(!grc.id) delete grc.id
}